import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useHomePageEditorContext } from '../provider';
import Description from './description';
import CreateMailProvider, { useCreateContext } from './provider';
import { BootstrapDialog, StyledActionContainer, StyledButtonCancel, StyledButtonSave } from './styles.css';

function DescriptionDialog() {
  return (
    <CreateMailProvider>
      <Component />
    </CreateMailProvider>
  );
}


function Component() {
  const { openDescription, setOpenDescription } = useHomePageEditorContext();
  const { onSubmit } = useCreateContext();

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="sm"
      open={openDescription}
      onClose={() => setOpenDescription(false)} >
      <DialogTitle sx={{ m: 0, px: 4, pt: 3, borderBottom: 1, borderBottomColor: "#F1F5F9" }}>
        {"Promo Description Update"}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Description />
        </Stack>
      </DialogContent>
      <DialogActions>
        <StyledActionContainer>
          <StyledButtonCancel variant='outlined' onClick={() => setOpenDescription(false)} >CANCEL</StyledButtonCancel>
          <StyledButtonSave
            variant="contained"
            form="game-details-form"
            type="submit"
            onClick={onSubmit}
          >
            SAVE
          </StyledButtonSave>
        </StyledActionContainer>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default DescriptionDialog;